module.exports = __webpack_public_path__ + "static/caneta2-0c8e886c74e3c061737b716264be8347.svg";